module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/APY2Zc/tc-custom/9781460303955.jpg?1728851645607",
      "alt": "This image is the cover for the book Rancher's Dangerous Affair, Vengeance in Texas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rancher's Dangerous Affair, Vengeance in Texas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("\"You still push every one of my buttons.\"")]), _c('br'), _c('br'), _vm._v("Not long after Eliza Harvey-Reed got married, her husband  David's infidelity proved she married the wrong brother. But was Brandon Reed, her old high-school flame, the "), _c('i', [_vm._v("right")]), _vm._v(" one? Now Eliza's back in their hometown of Vengeance, Texas. And when she first lays eyes on Brandon, it's obvious the heat between  them is as all-consuming as ever."), _c('br'), _c('br'), _vm._v("Brandon Reed's still furious that Eliza married his brother. Even more frustrating is that he can't help being drawn to her like a moth to a flame. But when David is murdered, Eliza tops the suspect list. Now Brandon must help clear her name before the real killer destroys his second chance at true love."), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennifer Morey\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Two-time RITA nominee and Golden Quill winner, Jennifer Morey writes her happy endings in Denver, Colorado. Aside from writing great contemporary and page-turning romantic suspense, she has a geology degree and consults compliance with the International Traffic in Arms Regulations. She loves movies, her three dogs, and her honey--not necessarily in that order! You may contact her through her website, "), _c('a', {
    attrs: {
      "href": "http://www.jennifermorey.co"
    }
  }, [_vm._v("www.jennifermorey.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0